import {
  Button,
  Box,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  Snackbar,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { db } from "../../services/firebase";
import MuiAlert from "@mui/material/Alert";
import { useState } from "react";
import "./style.css";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
// import EditIcon from "@mui/icons-material/Edit";
// import UploadFileIcon from "@mui/icons-material/UploadFile";

const dotStyle = {
  display: "inline-block",
  width: "8px",
  height: "8px",
  margin: "0 2px",
  borderRadius: "50%",
  backgroundColor: "#fff",
  animation: "dot-blink 0.5s infinite both",
};

const dotContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 30px",
};

const RegisterModal = ({
  openRegisterModal,
  setOpenRegisterModal,
  fetchAndSortCategories,
}) => {
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [snackbarContent, setsnackbarContent] = useState("");
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [snackbarMode, setSnackbarMode] = useState("");
  const [phoneError, setPhoneError] = useState("");

  // Add validation function
  const validatePhone = (value) => {
    // Only allow numbers
    if (/[a-zA-Z]/.test(value)) {
      setPhoneError("Phone number cannot contain letters");
      return false;
    }
    // Remove any validation error if input is valid
    setPhoneError("");
    return true;
  };
  
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const checkIDExists = async (id, excludeId = null) => {
    const q = query(collection(db, "excel"), where("id", "==", id));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) return false;
    if (excludeId) {
      // allow same name if it's the same document
      return !querySnapshot.docs.every((d) => d.id === excludeId);
    }
    return true;
  };

  const onRegisterHandle = async () => {
    setLoading(true);
    try {
      const exists = await checkIDExists(id.trim());
      if (exists) {
        setSnackbarMode("error");
        setsnackbarContent("Id already exists");
        setSuccessSnackbarOpen(true);
        return;
      }

      await addDoc(collection(db, "excel"), {
        name: name.trim(),
        phone: phone.trim(),
        id: id.trim(),
        addedon: Math.floor(Date.now() / 1000).toString(),
        food: false,
        kit: false,
        url: "",
      });

      setSnackbarMode("success");
      setsnackbarContent("Member added successfully");
      setSuccessSnackbarOpen(true);
      await fetchAndSortCategories();
      onCloseRegisterModal();
    } catch (error) {
      console.error("Error Registering Member:", error);
      setSnackbarMode("error");
      setsnackbarContent("Error registering member");
      setSuccessSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const onCloseRegisterModal = () => {
    setName("");
    setPhone("");
    setId("");
    setOpenRegisterModal(false);
  };

  return (
    <Dialog
      open={openRegisterModal}
      onClose={() => setOpenRegisterModal(false)}
    >
      <DialogTitle>Register Members</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            label="ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            label="Phone"
            value={phone}
            onChange={(e) => {
              const value = e.target.value;
              if (validatePhone(value)) {
                setPhone(value);
              }
            }}
            onKeyPress={(e) => {
              // Prevent typing letters
              if (/[a-zA-Z]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            error={!!phoneError}
            helperText={phoneError}
            fullWidth
            sx={{ mt: 2 }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
          />
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="outlined" onClick={() => onCloseRegisterModal()}>
          Cancel
        </Button>
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          color="success"
          fullWidth
          onClick={() => onRegisterHandle()}
          sx={{ fontWeight: "bold" }}
          disabled={loading || !id.trim() || !name.trim() || !phone.trim()}
        >
          {loading ? (
            <Box sx={{ ...dotContainerStyle }}>
              <Box sx={{ ...dotStyle, animationDelay: "0s" }}></Box>
              <Box sx={{ ...dotStyle, animationDelay: "0.2s" }}></Box>
              <Box sx={{ ...dotStyle, animationDelay: "0.4s" }}></Box>
              <Box sx={{ ...dotStyle, animationDelay: "0.6s" }}></Box>
              <Box sx={{ ...dotStyle, animationDelay: "0.8s" }}></Box>
            </Box>
          ) : (
            "Register"
          )}
        </Button>
      </DialogActions>
      <Snackbar
        open={successSnackbarOpen}
        autoHideDuration={4000}
        onClose={() => handleSnackbarClose()}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => handleSnackbarClose()}
          severity={snackbarMode}
          sx={{ width: "100%" }}
        >
          {snackbarContent} !
        </MuiAlert>
      </Snackbar>
    </Dialog>
  );
};

export default RegisterModal;
